function setDynamicFontSize(className) {
  const anchorBadge = document.querySelector(className);
  const badges = document.querySelectorAll(className);
  const text = anchorBadge.querySelector('span');

  badges.forEach(badge => {
    badge.style.opacity = 0;
  });

  // Calculate available height for text
  const badgeHeight = anchorBadge.offsetHeight;
  const availableHeight = badgeHeight * 0.46;

  const tempElement = anchorBadge.querySelector('.temp');

  // Initialize font size
  let fontSize = 8; // Initial font size
  tempElement.style.fontSize = fontSize + 'px';
  tempElement.textContent = text.textContent;

  // Adjust font size to fit the text within the available height
  if (tempElement.offsetHeight > availableHeight) {
    // Decrease font size if text is too tall
    while (tempElement.offsetHeight > availableHeight && fontSize > 0) {
      fontSize -= 0.01;
      tempElement.style.fontSize = fontSize + 'px';
    }
  } else {
    // Increase font size if there is more space
    while (tempElement.offsetHeight < availableHeight) {
      fontSize += 0.01;
      tempElement.style.fontSize = fontSize + 'px';

      // Stop if increasing the font size makes the text too tall
      if (tempElement.offsetHeight > availableHeight) {
        fontSize -= 0.01;
        tempElement.style.fontSize = fontSize + 'px';
        break;
      }
    }
  }

  badges.forEach(badge => {
    badge.style.opacity = 1;
    let text = badge.querySelector('span');
    text.style.fontSize = fontSize + 'px';
  });
}

function dynamicFontSize() {
  if(document.querySelector('.product .popular_badge_custom')){
    setDynamicFontSize('.product .popular_badge_custom');
  }
  if(document.querySelector('.card .popular_badge_custom')){
    setDynamicFontSize('.card .popular_badge_custom');
  }
}
window.addEventListener("load", (event) => {
  // dynamicFontSize();
  const badges = document.querySelectorAll('.popular_badge_custom');
    badges.forEach(badge => {
      badge.style.opacity = 1;
    })
});
